<template>
  <page-list
    :list="list"
    :columns="changedColumns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :showSearchbox="showSearchbox"
    :showGroupActions="showGroupActions"
    :export-data-options="exportDataOptions"
    showTagConfig>
    <template v-slot:group-actions-append v-if="!defaultDate">
      <date-time
        class="ml-2"
        :getParams.sync="dateParam"
        :dateMode.sync="dateMode"
        paramTimeFormatter="YYYY-MM-DDTZ"
        showStartMonthTip
        @refresh="fetchData" />
    </template>
    <template v-slot:table-prepend>
      <total-price :currencySign="currencySign" :total="total_amount" :secondary_total="total_secondary_amount" setSecondaryToAmount />
    </template>
  </page-list>
</template>

<script>
import * as R from 'ramda'
import TotalPrice from '@Bill/sections/TotalPrice'
import ContractMixin from '@Bill/mixins/contract'
import currencyRequest from '@Bill/mixins/currencyRequest'
import TotalPriceMixin from '@Bill/mixins/totalPrice'
import { getAmountColumns } from '@Bill/utils'
// import { numerify } from '@/filters'
import ListMixin from '@/mixins/list'
import WindowsMixin from '@/mixins/windows'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'CloudProjectList',
  components: {
    TotalPrice,
  },
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, currencyRequest, TotalPriceMixin, ContractMixin],
  props: {
    id: String,
    getParams: {
      type: Object,
      default: () => ({}),
    },
    cloudEnv: String,
    isAllowCreate: {
      type: Boolean,
      default: true,
    },
    hiddenActions: {
      type: Array,
      default: () => ([]),
    },
    defaultDate: Object,
    defaultDateMode: String,
    billShared: Boolean,
    projectShared: Boolean,
  },
  data () {
    return {
      batchDeleteBill: true,
      dateMode: this.defaultDateMode || 'month',
      dateParam: this.defaultDate || {},
      list: this.$list.createList(this, {
        id: this.id,
        apiVersion: 'v1',
        idKey: 'external_project_name',
        resource: 'billsanalysises',
        getParams: this.getParam,
        fetchDataCb: this.getTotal,
        filterOptions: {
          name: {
            label: this.$t('table.title.name'),
            filter: true,
            formatter: val => {
              return `external_project_name.contains('${val}')`
            },
          },
        },
      }),
    }
  },
  computed: {
    changedColumns () {
      const columns = R.clone(this.columns)
      const amountColumns = getAmountColumns({
        disable_cost_conversion: this.currencyParams.disable_cost_conversion,
        dateMode: this.dateMode,
        amountContractColumn: this.billContractColumns[0] || null,
        currencySign: this.currencySign,
      })
      return [...columns, ...amountColumns]
    },
    exportDataOptions () {
      return {
        downloadType: 'local',
        title: this.$t('bill.external_project'),
        items: this.changedColumns,
      }
    },
    extTagParams () {
      const param = {}
      if (this.dateParam.start_date) {
        param.start_day = this.$moment(this.dateParam.start_date.replace('TZ', '')).format('YYYYMMDD')
        param.end_day = this.$moment(this.dateParam.end_date.replace('TZ', '')).format('YYYYMMDD')
      }
      return param
    },
  },
  watch: {
    currencyParams: {
      handler: function () {
        this.fetchData()
      },
    },
    deep: true,
    billShared () {
      this.fetchData()
    },
    projectShared () {
      this.fetchData()
    },
  },
  created () {
    this.$dM = new this.$Manager('billsanalysises')
    this.tagManagerInstance2 = new this.$Manager('project_tag_details', 'v1')
    this.initSidePageTab('overview')
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.list.fetchData()
    },
    getParam () {
      const getParams = (R.is(Function, this.getParams) ? this.getParams() : this.getParams)
      const ret = {
        details: false,
        query_type: 'external_project_name_expense',
        start_date: this.$moment().startOf('month').format('YYYY-MM-DD') + 'TZ',
        end_date: this.$moment().endOf('month').format('YYYY-MM-DD') + 'TZ',
        ...this.currencyParams,
        ...getParams,
        ...this.dateParam,
        ...(this.billContractParams || {}),
      }
      if (getParams.filter) {
        // delete ret.filter
        ret.filter = [this.currencyParams.filter, getParams.filter]
      }
      if (this.billShared) {
        ret.is_prepaid_amortizing = true
      } else {
        ret.is_prepaid_amortizing = false
      }
      if (this.projectShared) {
        ret.is_project_sharing = true
      } else {
        ret.is_project_sharing = false
      }
      return ret
    },
    handleOpenSidepage (row) {
      console.log(row)
      this.sidePageTriggerHandle(this, 'CloudExternalprojectSidePage', {
        id: row.external_project_name,
        resource: () => {
          return {
            data: row,
          }
        },
      }, {
        list: this.list,
        hiddenActions: this.hiddenActions,
      })
    },
  },
}
</script>
